module.exports = __webpack_public_path__ + "img/es.8b4e78c9.png";